// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Download_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 13.5v6a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 19.5v-6a.75.75 0 0 1 1.5 0v5.25h15V13.5a.75.75 0 0 1 1.5 0Zm-9.53.53a.75.75 0 0 0 1.06 0l3.75-3.75a.75.75 0 0 0-1.06-1.06l-2.47 2.47V3a.75.75 0 0 0-1.5 0v8.69L8.78 9.22a.75.75 0 0 0-1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'Download_Stroke2_Corner0_Rounded',
})
